module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticStyle: {
      "padding-left": "10px"
    }
  }, _vm._l((_vm.attr), function(v, k, i) {
    return (_vm.attr) ? _c('div', [(v.type === 'text') ? _c('mu-text-field', {
      attrs: {
        "label": k,
        "name": k,
        "type": "text",
        "fullWidth": ""
      },
      nativeOn: {
        "input": function($event) {
          _vm.updateAttribute($event)
        }
      },
      model: {
        value: (v.value),
        callback: function($$v) {
          v.value = $$v
        },
        expression: "v.value"
      }
    }) : _vm._e(), _vm._v(" "), (v.type === 'number') ? _c('mu-text-field', {
      attrs: {
        "label": k,
        "name": k,
        "type": "number",
        "fullWidth": ""
      },
      nativeOn: {
        "input": function($event) {
          _vm.updateAttribute($event)
        }
      },
      model: {
        value: (v.value),
        callback: function($$v) {
          v.value = $$v
        },
        expression: "v.value"
      }
    }) : _vm._e(), _vm._v(" "), (v.type === 'slider') ? _c('small', [_vm._v(_vm._s(k + ': ' + v.value))]) : _vm._e(), _vm._v(" "), (v.type === 'slider') ? _c('mu-slider', {
      attrs: {
        "step": v.step,
        "max": v.max,
        "min": v.min
      },
      nativeOn: {
        "mouseup": function($event) {
          _vm.updateAttribute($event)
        }
      },
      model: {
        value: (v.value),
        callback: function($$v) {
          v.value = $$v
        },
        expression: "v.value"
      }
    }) : _vm._e(), _vm._v(" "), (v.type === 'label') ? _c('div', {
      staticClass: "mu-text-field-label"
    }, [_vm._v(_vm._s(v.value))]) : _vm._e(), _vm._v(" "), (v.type === 'boolean') ? _c('mu-switch', {
      style: ({
        width: '100%',
        marginBottom: '10px'
      }),
      attrs: {
        "label": k,
        "labelLeft": ""
      },
      on: {
        "change": _vm.updateAttribute
      },
      model: {
        value: (v.value),
        callback: function($$v) {
          v.value = $$v
        },
        expression: "v.value"
      }
    }) : _vm._e(), _vm._v(" "), (v.type === 'selection') ? _c('mu-select-field', {
      staticStyle: {
        "width": "100%"
      },
      attrs: {
        "label": k
      },
      on: {
        "input": _vm.updateAttribute
      },
      model: {
        value: (v.value),
        callback: function($$v) {
          v.value = $$v
        },
        expression: "v.value"
      }
    }, _vm._l((v.items), function(item, index) {
      return _c('mu-menu-item', {
        key: index,
        attrs: {
          "value": item,
          "title": item
        }
      })
    })) : _vm._e(), _vm._v(" "), (v.type === 'icon') ? _c('iconPicker', {
      attrs: {
        "name": k
      },
      on: {
        "change": _vm.updateAttribute
      },
      model: {
        value: (v.value),
        callback: function($$v) {
          v.value = $$v
        },
        expression: "v.value"
      }
    }) : _vm._e(), _vm._v(" "), (v.type === 'ionicon') ? _c('ioniconPicker', {
      attrs: {
        "name": k
      },
      on: {
        "change": _vm.updateAttribute
      },
      model: {
        value: (v.value),
        callback: function($$v) {
          v.value = $$v
        },
        expression: "v.value"
      }
    }) : _vm._e(), _vm._v(" "), (v.type === 'color') ? _c('colorPicker', {
      attrs: {
        "name": k
      },
      on: {
        "change": _vm.updateAttribute
      },
      model: {
        value: (v.value),
        callback: function($$v) {
          v.value = $$v
        },
        expression: "v.value"
      }
    }) : _vm._e(), _vm._v(" "), (v.children) ? _c('subAttributes', {
      attrs: {
        "keyOfAttr": k,
        "attributes": v.children
      },
      on: {
        "update": _vm.subUpdate
      }
    }) : _vm._e()], 1) : _vm._e()
  }))
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-68a0be0c","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/subAttribute.vue
// module id = 561
// module chunks = 1